export const getBackgroundColor = (color) => {
    switch (color) {
        case 'portsmouthNavySuperdark':
            return 'bg-primary-portsmouthNavySuperdark';
        case 'bregRiverBlue':
            return 'bg-primary-bregRiverBlue';
        case 'lakeBledBlue':
            return 'bg-secondary-lakeBledBlue';
        case 'singaporeOrange':
            return 'bg-secondary-singaporeOrange';
        case 'singaporeLight':
            return 'bg-tertiary-singaporeLight';
        case 'yorkShireCyan':
            return 'bg-secondary-yorkShireCyan';
        case 'bledLakeMed':
            return 'bg-tertiary-bledLakeMed';
        case 'lightGray':
            return 'bg-lightGray';
        case 'white':
            return 'bg-white';
        case 'portsmouthNavy':
        default:
            return 'bg-primary-portsmouthNavy';
    }
};
export const getTextColor = (color) => {
    switch (color) {
        case 'portsmouthNavy':
            return 'text-primary-portsmouthNavy';
        case 'portsmouthNavySuperdark':
            return 'text-primary-portsmouthNavySuperdark';
        case 'bregRiverBlue':
            return 'text-primary-bregRiverBlue';
        case 'lakeBledBlue':
            return 'text-secondary-lakeBledBlue';
        case 'singaporeOrange':
            return 'text-secondary-singaporeOrange';
        case 'singaporeLight':
            return 'text-tertiary-singaporeLight';
        case 'yorkShireCyan':
            return 'text-secondary-yorkShireCyan';
        case 'bledLakeMed':
            return 'text-tertiary-bledLakeMed';
        case 'lightGray':
            return 'text-lightGray';
        case 'white':
        default:
            return 'text-white';
    }
};
// TODO
// TBD
export const getTextColorByBgColor = (bgColor) => {
    switch (bgColor) {
        case 'white':
        case 'lightGray':
        case 'yorkShireCyan':
        case 'singaporeLight':
            return 'text-primary-portsmouthNavy';
        case 'portsmouthNavy':
        case 'portsmouthNavySuperdark':
        case 'bregRiverBlue':
        case 'singaporeOrange':
        case 'lakeBledBlue':
        case 'bledLakeMed':
        default:
            return 'text-white';
    }
};
export const getBorderColor = (color) => {
    switch (color) {
        case 'portsmouthNavySuperdark':
            return 'border-primary-portsmouthNavySuperdark';
        case 'bregRiverBlue':
            return 'border-primary-bregRiverBlue';
        case 'lakeBledBlue':
            return 'border-secondary-lakeBledBlue';
        case 'singaporeOrange':
            return 'border-secondary-singaporeOrange';
        case 'yorkShireCyan':
            return 'border-secondary-yorkShireCyan';
        case 'bledLakeMed':
            return 'border-tertiary-bledLakeMed';
        case 'lightGray':
            return 'border-lightGray';
        case 'white':
            return 'border-white';
        case 'portsmouthNavy':
        default:
            return 'border-primary-portsmouthNavy';
    }
};
export const getBorderColorByBgColor = (bgColor) => {
    switch (bgColor) {
        default:
        case 'white':
            return 'border-mediumGray';
        case 'portsmouthNavy':
        case 'portsmouthNavySuperdark':
            return 'border-tertiary-bledLakeMed';
        case 'yorkShireCyan':
            return 'border-tertiary-yorkShireMed';
        case 'singaporeOrange':
            return 'border-tertiary-singaporeMed';
    }
};
export const getOutlineColorByBgColor = (bgColor) => {
    switch (bgColor) {
        default:
        case 'white':
            return 'outline-mediumGray';
        case 'portsmouthNavy':
        case 'portsmouthNavySuperdark':
            return 'outline-tertiary-bledLakeMed';
        case 'yorkShireCyan':
            return 'outline-tertiary-yorkShireMed';
        case 'singaporeOrange':
            return 'outline-tertiary-singaporeMed';
    }
};
export const getHoverShadowClasses = (blockBackground) => {
    switch (blockBackground) {
        case 'portsmouthNavy':
        case 'portsmouthNavySuperdark':
            return 'hover:shadow-light';
        default:
            return 'hover:shadow-dark';
    }
};
export const getAfterContentColorByBgColor = (bgColor) => {
    switch (bgColor) {
        case 'white':
        case 'lightGray':
        case 'yorkShireCyan':
        case 'singaporeLight':
            return 'after:text-primary-portsmouthNavy';
        case 'portsmouthNavy':
        case 'portsmouthNavySuperdark':
        case 'bregRiverBlue':
        case 'singaporeOrange':
        case 'lakeBledBlue':
        case 'bledLakeMed':
        default:
            return 'after:text-white';
    }
};
